"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Image from "next/image";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const slides = [
  /*{ id: 1, image: "/images/fachadanuea.png" },*/
  { id: 3, image: "/images/carrener1.png"},
  { id: 6, image: "/images/carrferr1.png"},
  { id: 7, image: "/images/carriego1.png" },
  { id: 8, image: "/images/carrindu1.png"},
  { id: 9, image: "/images/carrjardin1.png" },
  { id: 10, image: "/images/carrmaq1.png" },
  { id: 11, image: "/images/carrpecuario1.png"},
  { id: 12, image: "/images/carrplastico1.png" },
];

export default function CarouselHero() {
  return (
    <section className="w-full overflow-hidden bg-green rounded-3xl"> 
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop
        className="w-full"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id} className="w-full active:cursor-grabbing">
            <div className="relative w-full aspect-[1200/540] max-h-[75vh] ">
              <Image
                src={slide.image}
                alt="Banner de producto"
                fill
                priority
                sizes="100vw"
                className="object-contain object-center" 
              />
              <div className="absolute inset-0 bg-green/5 " />
              <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-green/40 to-transparent" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
